module.exports = __webpack_public_path__ + "img/photosession_1_6.de1f8ade.jpg";